import { Amplify } from "aws-amplify";

const cognitoConfig = {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
  identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID,
  region: import.meta.env.VITE_COGNITO_REGION || "us-west-1",
  domain: import.meta.env.VITE_COGNITO_DOMAIN,
};

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: cognitoConfig.userPoolId,
      userPoolClientId: cognitoConfig.userPoolClientId,
      identityPoolId: cognitoConfig.identityPoolId,
      loginWith: {
        oauth: {
          domain: cognitoConfig.domain,
          scopes: ["phone", "email", "openid"],
          redirectSignIn: [import.meta.env.VITE_COGNITO_SIGN_IN_URL],
          redirectSignOut: [import.meta.env.VITE_COGNITO_SIGN_OUT_URL],
          responseType: "code",
        },
      },
    },
  },
});

export const amplifyConfig = {
  cognito: cognitoConfig,
  apiUrl: import.meta.env.VITE_API_URL,
  accessControlApiUrl: import.meta.env.VITE_ACCESS_CONTROL_API_URL,
  environment: import.meta.env.VITE_ENVIRONMENT || "dev",
};
